<template>
    <UtilPanelContent>
<!--        <v-overlay v-model="showOverlay"></v-overlay>-->
        <template v-slot:utils>
            <div v-if="stShowSettings">
                <Settings
                    :isBookFunctionality="true"
                    @close-settings="showSettings"
                    class="elevation-11 border-radius-1"
                />
            </div>
            <!-- <div v-if="stShowQuestions">
                <Questions @close-question="showQuestions" class="elevation-11 border-radius-1" />
            </div> -->
            <div v-if="stShowMusic">
                <Music
                    :isBookFunctionality="true"
                    @close-music="showMusic"
                    class="elevation-11 border-radius-1"
                />
            </div>
            <div v-if="stShowDictionary">
                <Dictionary
                    @close-dictionary="openDictionary"
                    v-if="stShowDictionary"
                    class="elevation-11 border-radius-1"
                />
            </div>
            <div v-if="stShowNotes" transition="slide-x-transition">
                <StickyNotes @close-note="showNotes" class="elevation-11 border-radius-1" />
            </div>
            <div v-show="stShowReadaloud" transition="slide-x-transition">
                <ReadAloud @close-reading="showReadaloud" class="elevation-11 border-radius-1" />
            </div>
        </template>
        <div class="transition-all">
            <div class="d-flex flex-column justify-center align-center w-100">
                <div class="bg-white w-100">
                    <v-btn
                        data-cy="utilsPanel-showIndexModal-button"
                        text
                        block
                        x-large
                        class="w-100 ma-0 py-6 d-flex justify-end align-center"
                        @click="openBottomSheet(stShowIndex)"
                    >
                        <div class="d-flex flex-column justify-center align-end option--primary ml-15 mr-2 transition-all">
                            <span class="font-size-16 text-capitalize line-height-100">{{ texts.indexTxt.text }} </span>
                            <span class="font-size-10 text-capitalize"
                                >{{ texts.indexTxt.trl }}
                            </span>
                        </div>
                        <img class="reading-util-icon" :src="indexImg" alt="index image icon"
                    /></v-btn>
                    <v-btn
                        data-cy="utilsPanels-settings-button"
                        text
                        block
                        x-large
                        class="w-100 ma-0 py-6 d-flex justify-end align-center"
                        @click="openSettingsSheetComponent"
                        >
                        <div class="d-flex flex-column justify-center align-end option--primary ml-15 mr-2">
                            <span class="font-size-16 text-capitalize line-height-100">{{ texts.settingTxt.text }} </span>
                            <span class="font-size-10 text-capitalize"
                                >{{ texts.settingTxt.trl }}
                            </span>
                        </div>
                        <img height="32" width="32" class="reading-util-icon" :src="settingImg" />
                    </v-btn>
                    <!-- <v-btn
                        data-cy="utilsPanels-questions-button"
                        text
                        block
                        x-large
                        :class="
                            'w-100 ma-0 py-6 d-flex justify-end align-center ' +
                            (hasQuestion ? 'animated infinite bounce delay-2s' : '')
                        "
                        @click="openQuestionsSheetComponent"
                        id="btn-question"
                        ><div
                            class="d-flex flex-column justify-center align-end option--primary ml-15 mr-2"
                            
                        >
                            <span class="font-size-16 text-capitalize line-height-100">{{ texts.questionsTxt.text }} </span>
                            <span class="font-size-10 text-capitalize"
                                >{{ texts.questionsTxt.trl }}
                            </span>
                        </div>
                        <img
                            class="reading-util-icon"
                            :src="questionsImg"
                            alt="question image icon"
                        />
                    </v-btn> -->
                </div>
                    <v-btn
                        data-cy="utilsPanel-showHighlights-button"
                        block
                        x-large
                        color="transparent"
                        elevation="0"
                        class="w-100 ma-0 border-radius-0 py-6 d-flex justify-end align-center"
                        @click="openHighlightBottomSheet"
                        ><div
                            class="d-flex flex-column justify-center align-end option--white ml-15 mr-2"                         
                        >
                            <span class="font-size-16 text-capitalize line-height-100">{{ texts.highlightingsTxt.text }} </span>
                            <span class="font-size-10 text-capitalize"
                                >{{ texts.highlightingsTxt.trl }}
                            </span>
                        </div>
                        <img class="reading-util-icon" :src="highlightingsImg" />
                    </v-btn>
                    <v-btn
                        data-cy="utilsPanels-notes-button"
                        block
                        x-large
                        color="transparent"
                        elevation="0"
                        class="w-100 ma-0 border-radius-0 py-6 d-flex justify-end align-center"
                        @click="openNoteSheetComponent"
                        ><div
                            class="d-flex flex-column justify-center align-end option--white ml-15 mr-2"
                            
                        >
                            <span class="font-size-16 text-capitalize line-height-100">{{ texts.notesTxt.text }} </span>
                            <span class="font-size-10 text-capitalize"
                                >{{ texts.notesTxt.trl }}
                            </span>
                        </div>
                        <img class="reading-util-icon" :src="notesImg" />
                    </v-btn>
                    <v-btn
                        data-cy="utilsPanels-dictionary-button"
                        block
                        x-large
                        color="transparent"
                        elevation="0"
                        class="w-100 ma-0 border-radius-0 py-6 d-flex justify-end align-center"
                        @click="openDictionarySheetComponent"
                        ><div
                            class="d-flex flex-column justify-center align-end option--white ml-15 mr-2"
                            
                        >
                            <span class="font-size-16 text-capitalize line-height-100">{{ texts.dictionaryTxt.text }} </span>
                            <span class="font-size-10 text-capitalize"
                                >{{ texts.dictionaryTxt.trl }}
                            </span>
                        </div>
                        <img class="reading-util-icon" :src="dictionaryImg" />
                    </v-btn>
                    <v-btn
                        data-cy="utilsPanels-narrator-button"
                        block
                        x-large
                        color="transparent"
                        elevation="0"
                        class="w-100 ma-0 border-radius-0 py-6 d-flex justify-end align-center"
                        @click="openReadAloudSheetComponent"
                        ><div
                            class="d-flex flex-column justify-center align-end option--white ml-15 mr-2"
                            
                        >
                            <span class="font-size-16 text-capitalize line-height-100">{{ texts.readaloudTxt.text }} </span>
                            <span class="font-size-10 text-capitalize"
                                >{{ texts.readaloudTxt.trl }}
                            </span>
                        </div>
                        <img class="reading-util-icon" :src="readaloudImg" />
                    </v-btn>
                    <v-btn
                        data-cy="utilsPanels-music-button"
                        block
                        x-large
                        color="transparent"
                        elevation="0"
                        class="w-100 ma-0 border-radius-0 py-6 d-flex justify-end align-center"
                        @click="openMusicSheetComponent"
                        ><div
                            class="d-flex flex-column justify-center align-end option--white ml-15 mr-2"
                            
                        >
                            <span class="font-size-16 text-capitalize line-height-100">{{ texts.musicTxt.text }} </span>
                            <span class="font-size-10 text-capitalize"
                                >{{ texts.musicTxt.trl }}
                            </span>
                        </div>
                        <img class="reading-util-icon" :src="musicImg" />
                    </v-btn>
            </div>
        </div>
        <IndexSheet ref="IndexSheetComponent"></IndexSheet>
        <HighlightSheet ref="HighlightSheetComponent"></HighlightSheet>
        <SettingsSheetVue ref="SettingsSheetComponent"></SettingsSheetVue>
        <NoteSheet ref="NoteSheetComponent"></NoteSheet>
        <DictionarySheet ref="DictionarySheetComponent"></DictionarySheet>
        <ReadAloudSheet ref="ReadAloudSheetComponent"></ReadAloudSheet>
        <MusicSheet ref="MusicSheetComponent"></MusicSheet>
        <QuestionsSheet ref="QuestionsSheetComponent"></QuestionsSheet>
    </UtilPanelContent>
</template>
<script>
/* eslint-disable global-require */
import { mapActions, mapState } from 'vuex'

import Music from '@/components/core/utils/Music.vue'
import ReadAloud from '@/components/core/utils/ReadAloud.vue'
import UtilPanelContent from '@/components/core/utils/UtilPanelContent.vue'
import Dictionary from '@/components/core/utils/Dictionary.vue'
import Settings from '@/components/core/utils/Settings.vue'
import Index from './bookUtils/Index.vue'
import Questions from './bookUtils/Questions.vue'
import Highlight from './bookUtils/Highlight.vue'
import StickyNotes from './bookUtils/StickyNotes.vue'
import IndexSheet from './IndexSheet.vue'
import HighlightSheet from './HighlightSheet.vue'
import SettingsSheetVue from './SettingsSheet.vue'
import NoteSheet from './NoteSheet.vue'
import DictionarySheet from './DictionarySheet.vue'
import ReadAloudSheet from './ReadAloudSheet.vue'
import MusicSheet from './MusicSheet.vue'
import QuestionsSheet from './QuestionsSheet.vue'

export default {
    components: {
        Index,
        Settings,
        Questions,
        Highlight,
        Music,
        Dictionary,
        StickyNotes,
        ReadAloud,
        UtilPanelContent,
        IndexSheet,
        HighlightSheet,
        SettingsSheetVue,
        NoteSheet,
        DictionarySheet,
        ReadAloudSheet,
        MusicSheet,
        QuestionsSheet
    },
    data() {
        return {
            showTexts: false,
            indexImg: require('@/assets/img/icons/new-reading/index-purple.svg'),
            settingImg: require('@/assets/img/icons/new-reading/settings-purple.svg'),
            questionsImg: require('@/assets/img/icons/reading/3-questions.svg'),
            highlightingsImg: require('@/assets/img/icons/new-reading/highlighting-white.svg'),
            notesImg: require('@/assets/img/icons/new-reading/notes-white.svg'),
            dictionaryImg: require('@/assets/img/icons/new-reading/dictionary-white.svg'),
            readaloudImg: require('@/assets/img/icons/new-reading/read-aloud-white.svg'),
            musicImg: require('@/assets/img/icons/new-reading/music-white.svg'),
        }
    },
    methods: {
        ...mapActions('bookReading', [
            'showIndex',
            'showSettings',
            'showQuestions',
            'showMusic',
            'showDictionary',
            'showNotes',
            'setDictionaryMode',
            'showReadaloud',
            'showHighlights'
        ]),
        openDictionary() {
            this.setDictionaryMode('manual')
            this.showDictionary()
        },
        openBottomSheet() {
            // this.$refs.IndexSheetComponent.bottomSheet = true
            this.showIndex()
            this.$root.$emit('closeDrawer', false)
        },
        openHighlightBottomSheet() {
            // this.$refs.HighlightSheetComponent.bottomHighlightSheet = true
            this.showHighlights()
            this.$root.$emit('closeDrawer', false)
        },
        openSettingsSheetComponent() {
            // this.$refs.SettingsSheetComponent.bottomSettingsSheet = true
            this.showSettings()
            this.$root.$emit('closeDrawer', false)
        },
        openNoteSheetComponent() {
            // this.$refs.NoteSheetComponent.bottomNoteSheet = true
            this.showNotes()
            this.$root.$emit('closeDrawer', false)
        },
        openDictionarySheetComponent() {
            // this.$refs.DictionarySheetComponent.bottomDictionarySheet = true
            this.openDictionary()
            this.$root.$emit('closeDrawer', false)
        },
        openReadAloudSheetComponent() {
            // this.$refs.ReadAloudSheetComponent.bottomReadAloudSheet = true
            this.showReadaloud()
            this.$root.$emit('closeDrawer', false)
        },
        openMusicSheetComponent() {
            // this.$refs.MusicSheetComponent.bottomMusicSheet = true
            this.showMusic()
            this.$root.$emit('closeDrawer', false)
        },
        openQuestionsSheetComponent() {
            // this.$refs.QuestionsSheetComponent.bottomQuestionsSheet = true
            this.showQuestions()
            this.$root.$emit('closeDrawer', false)
        },
    },
    computed: {
        ...mapState({
            stShowIndex: (state) => state.bookReading.showIndex,
            stShowSettings: (state) => state.bookReading.showSettings,
            stShowQuestions: (state) => state.bookReading.showQuestions,
            stShowMusic: (state) => state.bookReading.showMusic,
            stShowDictionary: (state) => state.bookReading.showDictionary,
            stShowNotes: (state) => state.bookReading.showNotes,
            stShowReadaloud: (state) => state.bookReading.showReadaloud,
            hasQuestion: (state) => state.bookReading.hasQuestion,
            mobileShowIndex: (state) => state.bookReading.mobileTools.showIndex,
            mobileShowSettings: (state) => state.bookReading.mobileTools.showSettings,
            mobileShowQuestions: (state) => state.bookReading.mobileTools.showQuestions,
            mobileShowMusic: (state) => state.bookReading.mobileTools.showMusic,
            mobileShowDictionary: (state) => state.bookReading.mobileTools.showDictionary,
            mobileShowNotes: (state) => state.bookReading.mobileTools.showNotes,
            mobileShowReadaloud: (state) => state.bookReading.mobileTools.showReadaloud,
        }),
        showOverlay(){
            return this.stShowIndex || this.stShowSettings || this.stShowQuestions
                || this.stShowHighlights || this.stShowMusic || this.stShowDictionary
                || this.stShowNotes || this.stShowReadaloud
        },
        texts() {
            return {
                indexTxt: {
                    text: this.$t('bookReading.index'),
                    trl: this.$i18n.locale === 'es' ? 'Index' : 'Índice',
                },
                settingTxt: {
                    text: this.$t('bookReading.settings'),
                    trl: this.$i18n.locale === 'es' ? 'Settings' : 'Ajustes',
                },
                questionsTxt: {
                    text: this.$t('bookReading.question'),
                    trl: this.$i18n.locale === 'es' ? 'Questions' : 'Preguntas',
                },
                highlightingsTxt: {
                    text: this.$t('bookReading.marker'),
                    trl: this.$i18n.locale === 'es' ? 'Highlighting' : 'Marcadores',
                },
                notesTxt: {
                    text: this.$t('bookReading.notes'),
                    trl: this.$i18n.locale === 'es' ? 'My notes' : 'Mis notas',
                },
                dictionaryTxt: {
                    text: this.$t('bookReading.dictionary'),
                    trl: this.$i18n.locale === 'es' ? 'Dictionary' : 'Diccionario',
                },
                readaloudTxt: {
                    text: this.$t('bookReading.storyletter'),
                    trl: this.$i18n.locale === 'es' ? 'Read Aloud' : 'Narrador',
                },
                musicTxt: {
                    text: this.$t('bookReading.music'),
                    trl: this.$i18n.locale === 'es' ? 'Music' : 'Música',
                },
            }
        },
    },
}
</script>

<style lang="scss">
.bg-purple {
    background: #514773;
    border: 1.5px solid #514773;
}
.option{
    &--primary {
        color: #514773;
    }
    &--white {
        color: white;
    }
}
.util-bar{
    z-index: 5;
    .v-btn{
        span:first-of-type{
            font-weight: 600;
        }
    }
    .v-btn:not(.v-btn--round).v-size--x-large{
        height: 60px;
    }
    &-text {
        width: 12.5em !important;
    }
    &-non-text {
        width: 3.5em;
    }
    &-border {
        border-radius: 1vh;
    }
}
.bottom-radius {
    border-radius: 0 0 1vh 1vh !important;
}

.bg-white {
    background: white;
}
.border-bottom {
    border: 1.5px solid #514773 !important;
    background: #514773;
}

.content-shadow {
    box-shadow: 0 6px 7px -4px rgba(0, 0, 0, 0.2), 0 11px 15px 1px rgba(0, 0, 0, 0.14),
        0 4px 20px 3px rgba(0, 0, 0, 0.12) !important;
}
//PARA PRUEBAS
.util-bar {
    right: 0em;
    top: 5rem;
}

/* Medium devices (landscape tablets, 768px and up) */
// @media only screen and (min-width: 768px) {
//     .reading-util-icon {
//         width: 2.5vh;
//     }

//     .util-bar {
//         right: 6em;
//         top: 5rem;
//     }
// }

// /* Large devices (laptops/desktops, 992px and up) */
// @media only screen and (min-width: 992px) {
//     .reading-util-icon {
//         width: 2.5vh;
//     }
//     .util-bar {
//         right: 8em;
//         top: 5rem;
//     }
// }

// /* Extra large devices (large laptops and desktops, 1200px and up) */
// @media only screen and (min-width: 1200px) {
//     .reading-util-icon {
//         width: 3vh;
//     }
//     .util-bar {
//         right: 10em;
//         top: 5rem;
//     }
// }
</style>
